import {Component, OnInit, ElementRef, LOCALE_ID} from '@angular/core';
import {DocumentService} from '../../services/documents.service';
import {UserService} from '../../services/user.service';
import {User} from '../../models/user.model';
import {MatDialog, Sort, MatSort} from '@angular/material';
import {DatePipe} from '@angular/common';
import {SessionTimeoutDialogComponent} from '../session-timeout-dialog/session-timeout-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import 'rxjs/add/observable/of';
import {RequestModel} from '../../models/request.model';
import {ResponseModel} from '../../models/response.model';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css'],
  providers: [{provide: LOCALE_ID, useValue: 'es-MX'}]
})
export class DocumentsComponent implements OnInit {
  user: User;
  documents: ResponseModel = new ResponseModel();
  isPromiseDone = false;
  name: string;
  request = new RequestModel();
  totalDocuments = 25;
  pages: PagePosition[] = [];
  indeterminate = false;
  allDocuments = false;
  currPage = 0;
  lastClass = 'material-icons page-inactive';
  nextClass = 'material-icons page-inactive';
  prevClass = 'material-icons page-inactive';
  firstClass = 'material-icons page-inactive';
  noResults = false;

  constructor(private documentService: DocumentService, private elementRef: ElementRef,
              public dialog: MatDialog, private userService: UserService, private router: Router) { }

  selectAllDocuments() {
    for (const d of this.documents.Documents) {
      d.ViewFlag = this.allDocuments;
    }
    this.indeterminate = false;
  }

  jumpToPageNumber(page) {
    this.isPromiseDone = false;
    this.request.ItemsNo = this.totalDocuments;
    this.request.Page = page;
    this.currPage = page;
    this.loadData();
  }

  calculateAllDocumentsStatus() {
    let offStatus = false;
    let onStatus = false;
    for (const d of this.documents.Documents) {
      if (offStatus && onStatus) {
        break;
      }
      if (d.ViewFlag) {
        onStatus = true;
      } else {
        offStatus = true;
      }
    }
    if (offStatus && onStatus) {
      this.allDocuments = false;
      this.indeterminate = true;
    } else if (onStatus) {
      this.allDocuments = true;
      this.indeterminate = false;
    } else {
      this.allDocuments = false;
      this.indeterminate = false;
    }
  }

  nextPage() {
    let temp = this.documents.TotalOfDocuments / this.totalDocuments;
    temp = Math.trunc(temp) < temp ? Math.trunc(temp) : Math.trunc(temp) - 1;
    if (this.currPage === temp) {
      return;
    }
    this.currPage++;
    if (this.currPage >= temp) {
      this.currPage = temp;
    }
    this.isPromiseDone = false;
    this.request.ItemsNo = this.totalDocuments;
    this.request.Page = this.currPage;
    this.loadData();
  }

  prevPage() {
    if (this.currPage === 0) {
      return;
    }
    this.currPage--;
    if (this.currPage < 0) {
      this.currPage = 0;
    }
    this.isPromiseDone = false;
    this.request.ItemsNo = this.totalDocuments;
    this.request.Page = this.currPage;
    this.loadData();
  }

  firstPage() {
    this.currPage = 0;
    this.isPromiseDone = false;
    this.request.ItemsNo = this.totalDocuments;
    this.request.Page = this.currPage;
    this.loadData();
  }

  lastPage() {
    const temp = this.documents.TotalOfDocuments / this.totalDocuments;
    this.currPage = Math.trunc(temp) < temp ? Math.trunc(temp) : Math.trunc(temp) - 1;
    this.isPromiseDone = false;
    this.request.ItemsNo = this.totalDocuments;
    this.request.Page = this.currPage;
    this.loadData();
  }

  renderPaginationCtrl() {
    for (const p of this.pages) {
      p.ClassPagination = 'page-inactive';
    }
    this.pages[this.currPage].ClassPagination = 'page-active';
    this.lastClass = 'material-icons page-inactive';
    this.nextClass = 'material-icons page-inactive';
    this.prevClass = 'material-icons page-inactive';
    this.firstClass = 'material-icons page-inactive';
    if (this.currPage === this.pages.length - 1) {
      this.lastClass = 'material-icons page-disable';
      this.nextClass = 'material-icons page-disable';
    }
    if (this.currPage === 0) {
      this.firstClass = 'material-icons page-disable';
      this.prevClass = 'material-icons page-disable';
    }
    if (this.pages.length === 1) {
      this.nextClass = 'material-icons page-disable';
      this.prevClass = 'material-icons page-disable';
    }
  }

  loadData() {
    this.setCurrentSearch(this.request);
    this.currPage = this.request.Page;
    this.noResults = false;
    this.isPromiseDone = false;
    this.documentService.getDocumentsForUserPag(this.request).subscribe(data => {
      this.documents = data;
      if (data.Documents.length === 0) {
        this.noResults = true;
        this.isPromiseDone = true;
        return;
      }
      let temp = this.documents.TotalOfDocuments / this.request.ItemsNo;
      temp = Math.trunc(temp) < temp ? Math.trunc(temp) + 1 : Math.trunc(temp);
      this.pages = [];
      for (let i = 0; i < temp; i++) {
        const item = new PagePosition();
        item.Position = i;
        item.ClassPagination = 'page-inactive';
        this.pages.push(item);
      }
      this.pages[0].ClassPagination = 'page-active';
      if (this.pages.length === 1) {
        this.lastClass = 'page-disable';
        this.nextClass = 'page-disable';
        this.prevClass = 'page-disable';
        this.firstClass = 'page-disable';
      }

      this.renderPaginationCtrl();
      this.isPromiseDone = true;
    }, error => {
      if (error.status === 405) {
        this.dialog.closeAll();
        const dialogRef = this.dialog.open(SessionTimeoutDialogComponent, {
          width: '75%'
        });
      } else {
        this.userService.clearUser();
        this.router.navigate(['/login']);
      }
    });
  }

  newStatus(status) {
    this.request.Status = status;
    this.loadData();
  }

  loadingZip(res) {
    this.isPromiseDone = res;
    if (this.isPromiseDone) {
      this.allDocuments = false;
    }
  }

  ngOnInit() {
    this.user = this.userService.getUser();
    this.request.ItemsNo = this.totalDocuments;
    this.request.Page = this.currPage;
    this.request.Status = 'Sin Firmar';
    let res = this.loadCurrentSearch();
    if (res != null) {
      this.request = res;
    }
    this.loadData();
  }

  loadCurrentSearch(): RequestModel {
    const lastSearch = sessionStorage.getItem('docSearch');
    if (lastSearch != null && lastSearch !== undefined && lastSearch !== '') {
      return JSON.parse(lastSearch);
    }
    return null;
  }

  setCurrentSearch(p) {
    sessionStorage.setItem('docSearch', JSON.stringify(p));
  }
}

export class PagePosition {
  Position: number;
  ClassPagination: string;
  Status: string;
}



// WEBPACK FOOTER //
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/components/documents/documents.component.ts